import { TileLayer } from 'react-leaflet';

/** One OpenStreetMap host. The a/b/c subdomains drop tiles while panning on a phone. */
const TILE_URL = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';

/** Zoom and fade animations leave tiles invisible in the Android WebView. */
export const mapMotionOptions = {
  zoomAnimation: false,
  fadeAnimation: false,
  markerZoomAnimation: false,
} as const;

export default function AppTileLayer() {
  return (
    <TileLayer
      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      url={TILE_URL}
      maxZoom={19}
      maxNativeZoom={19}
      keepBuffer={6}
      updateWhenIdle
      updateWhenZooming={false}
      detectRetina={false}
    />
  );
}
